import { LinkedHashTag } from "@snapchat/web-core-ui";
import { toSlugUrl } from "@snapchat/web-slugify-url";
import { PageContext } from "@snapchat/web-frame";
import { PageType, reportWebAction, WebActionName } from "@snapchat/web-blizzard-reporting";
import styles from "./LensCreatorTags.module.css";
import { useCallback, useContext } from "react";
const UPPER_LIMIT = 20;
function ClickableTag({ creatorTag, webClientId }) {
    /* istanbul ignore next : Remove once test code is added */
    const handleClick = useCallback(() => {
        reportWebAction({
            pageType: PageType.LENS_PROFILE,
            webClientId,
            actionName: WebActionName.LensTagsCTA,
            actionSource: creatorTag,
        });
    }, [webClientId, creatorTag]);
    return (<LinkedHashTag hashTag={creatorTag} ariaLabel={creatorTag} href={`https://www.snapchat.com/explore/${toSlugUrl(creatorTag)}`} onClick={handleClick}/>);
}
export function LensCreatorTags({ creatorTags }) {
    const { webClientId = "" } = useContext(PageContext);
    return creatorTags?.length ? (<div className={styles.creatorTags}>
      {creatorTags.slice(0, UPPER_LIMIT).map((creatorTag) => (<ClickableTag creatorTag={creatorTag} webClientId={webClientId} key={creatorTag}/>))}
    </div>) : (<></>);
}
